import * as Sentry from "@sentry/react";
import { FullStory } from "@fullstory/browser";
import { SENTRY_DSN } from "./config";

// Analytics context that will be added to all track calls
let analyticsContext: {
  page?: string;
  path?: string;
  userId?: string;
  email?: string;
  isStaff?: boolean;
  quoteId?: string;
  orderedPartId?: string;
  ownerId?: string;
  [key: string]: any;
} = {};

const setContext = (context: {
  userId?: string;
  quoteId?: string;
  [key: string]: any;
}) => {
  analyticsContext = {
    ...analyticsContext,
    ...context,
  };
};

const clearContext = (keys?: string[]) => {
  if (!keys || keys.length === 0) {
    analyticsContext = {};
    return;
  }

  keys.forEach(key => {
    delete analyticsContext[key];
  });
};

const getContext = () => {
  return analyticsContext;
};

/* eslint-disable no-console */
const track = (eventName: string, props = {}) => {
  if (!window.analytics) {
    return;
  }

  try {
    // TODO: this is a working segment event title, double check whether we need to use something other than "Instant Quote App Clicked"
    window.analytics.track(eventName, {
      service: "instant-quote-app",
      affiliation: "quoting",
      page_url: typeof window !== `undefined` ? window.location.href : null,
      ...analyticsContext,
      ...props,
    });
  } catch (e) {
    console.error("Segment Track Error", e);
  }
};

const identify = ({
  id,
  firstName,
  lastName,
  emailAddress,
  isPunchout,
}: {
  id: string;
  emailAddress: string;
  firstName?: string;
  lastName?: string;
  isPunchout?: boolean;
}) => {
  // Update userId in context when identify is called
  setContext({ userId: id });

  if (window.analytics) {
    window.analytics.identify(id, {
      name: `${firstName || ""} ${lastName || ""}`.trim(),
      email: emailAddress,
      ...(isPunchout ? { punchout: 1 } : {}),
    });
  }
  if (SENTRY_DSN) {
    Sentry.setUser({ id, email: emailAddress });

    FullStory("setIdentity", {
      uid: id,
      properties: {
        displayName: `${firstName} ${lastName}`,
        email: emailAddress,
        // Add your own custom user variables here, details at
        // https://developer.fullstory.com/browser/identification/set-user-properties/
        // reviewsWritten: 14
      },
    });
  }
};

// TODO: do we need a 'category' param here like we have in the personalized-homepage-app?
const namedPageView = (name: string, data = {}) => {
  if (!window.analytics) {
    return;
  }
  try {
    window.analytics.page(name, {
      service: "instant-quote-app",
      ...data,
    });
  } catch (e) {
    console.error("Segment Page View Error", e);
  }
};

export { identify, namedPageView, track, setContext, clearContext, getContext };
